<mat-form-field>
  <input matInput placeholder="Nummer" [(ngModel)]="commissionNr">
</mat-form-field>

<div>
  <button mat-button (click)="dismiss()" color="primary">
    {{'orders.overlays.commission.cancel' | translate}}
  </button>
  <button mat-button (click)="save()" color="primary">
    {{'orders.overlays.commission.save' | translate}}
  </button>
</div>
